import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Card } from 'antd';
import { useAuth } from '../../../context/AuthContext';
import { employeeService } from '../../../services/employee/employee.service';
import { Employee } from '../../../types';
import { useApiErrorHandler } from '../../../hooks/useApiErrorHandler';
import EmployeeForm from '../components/EmployeeForm';

const UpdateEmployee: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const { token, selectedBranch } = useAuth();
    const [loading, setLoading] = useState(false);
    const [fetchLoading, setFetchLoading] = useState(false);
    const [employee, setEmployee] = useState<Employee | null>(null);
    const [formErrors, setFormErrors] = useState<Record<string, string[]>>({});
    const { handleError } = useApiErrorHandler();

    useEffect(() => {
        const fetchEmployee = async () => {
            if (!token || !id || !selectedBranch) return;

            setFetchLoading(true);
            try {
                const data = await employeeService.getEmployee(parseInt(id), token, selectedBranch.id);
                setEmployee(data);
            } catch (error) {
                handleError(error);
                navigate('/employees');
            } finally {
                setFetchLoading(false);
            }
        };

        fetchEmployee();
    }, [id, token]);

    const handleSubmit = async (values: any) => {
        if (!token || !id || !selectedBranch) return;

        setLoading(true);
        setFormErrors({});
        try {
            await employeeService.updateEmployee(parseInt(id), values, token, selectedBranch.id);
            navigate('/employees');
        } catch (error) {
            handleError(error, setFormErrors);
        } finally {
            setLoading(false);
        }
    };

    if (fetchLoading) {
        return <Card loading={true} />;
    }

    return (
        <Card title="Update Employee">
            {employee && (
                <EmployeeForm
                    initialValues={employee}
                    onSubmit={handleSubmit}
                    onCancel={() => navigate('/employees')}
                    loading={loading}
                    serverErrors={formErrors}
                />
            )}
        </Card>
    );
};

export default UpdateEmployee;
